import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import StarField from "../components/StarField";
import { setSeo } from "../lib/api";

export default function About() {
  useEffect(() => {
    setSeo(
      "About Us | Shillong Lucky Ending - Rules, Age Limit & Prize Structure",
      "Learn about Shillong Lucky Ending: how the 0-9 ending game works, prize structure (₹11 wins ₹100, ₹55 wins ₹500, ₹110 wins ₹1000), rules, age limit and responsible play."
    );
  }, []);

  return (
    <div data-testid="about-page">
      <StarField />
      <Header />
      <div className="page-header">
        <h1>About Us</h1>
      </div>
      <div className="content-area">
        <div className="content-inner" data-testid="about-content">
          <p>
            <strong>कृपया खेल के नियमों का पालन करें, आयु सीमा का ध्यान रखें और हमेशा ज़िम्मेदारी से खेलें।</strong>{" "}
            हमारा गेम <strong>शिलांग लकी एंडिंग</strong> जैसा एक <strong>एंडिंग गेम</strong> है, जिसमें{" "}
            <strong>0 से 9 तक</strong> के अंकों के बीच परिणाम आते हैं। हमारे गेम में <strong>₹11 का प्राइस ₹100</strong>,{" "}
            <strong>₹55 का प्राइस ₹500</strong>, और <strong>₹110 का प्राइस ₹1000</strong> मिलता है।
          </p>

          <h2>Who We Are</h2>
          <p>
            <strong>Shillong Lucky Ending</strong> is a dedicated result portal for the popular{" "}
            <strong>ending game</strong> of Meghalaya. Every day, from <strong>09:00 AM to 08:00 PM</strong>, a single
            lucky digit between <strong>0 and 9</strong> is declared for each 15-minute slot. Our mission is simple: to
            publish every result <strong>fast, accurately and transparently</strong>, so that followers never have to
            rely on rumours or delayed updates. You can see the live digit on our{" "}
            <Link className="inlink" to="/">home page</Link> and browse the full 7-day chart on the{" "}
            <Link className="inlink" to="/all-result-list">All Results</Link> page.
          </p>

          <h2>How the Ending Game Works</h2>
          <p>
            The game is based on the <strong>last digit</strong> of the declared number. If the round result is 47,
            the ending digit is <strong>7</strong>. Players choose any digit from 0 to 9 before the slot closes. When
            the official digit is declared and it matches your choice, you win according to the prize structure below.
            Because only ten outcomes are possible, the game is easy to understand, yet every slot remains completely
            unpredictable.
          </p>

          <h2>Prize Structure</h2>
          <ul>
            <li>
              <strong>₹11 play → ₹100 prize</strong>
            </li>
            <li>
              <strong>₹55 play → ₹500 prize</strong>
            </li>
            <li>
              <strong>₹110 play → ₹1000 prize</strong>
            </li>
          </ul>
          <p>
            Prizes are paid strictly on the <strong>declared ending digit</strong> of the specific time slot. Please
            keep your ticket safe and always cross-check the slot time shown next to the live result.
          </p>

          <h2>Rules You Must Follow</h2>
          <ul>
            <li>
              <strong>Age limit:</strong> You must be <strong>18 years or older</strong> to participate.
            </li>
            <li>
              <strong>One digit per entry:</strong> Each entry is valid for a single digit (0-9) in a single slot.
            </li>
            <li>
              <strong>Timing:</strong> Entries close before the slot result is declared. Late entries are not accepted.
            </li>
            <li>
              <strong>Verification:</strong> Only the result published here or shared from our official admin panel
              is valid.
            </li>
            <li>
              <strong>Responsible play:</strong> Set a budget, never chase losses, and treat the game as entertainment
              only.
            </li>
          </ul>

          <h2>Our Commitment to Transparency</h2>
          <p>
            All numbers are entered through a secure admin system and permanently stored in our database. Nothing is
            edited after declaration. For a complete understanding of how your data is handled please read our{" "}
            <Link className="inlink" to="/privacy">Privacy Policy</Link>, and review the{" "}
            <Link className="inlink" to="/terms">Terms &amp; Conditions</Link> before using this site. Have a
            question? Reach us any time through the <Link className="inlink" to="/contact">Contact Us</Link> page.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
